import { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { ClipPath, Color, Defs, G, Path, Svg } from "react-native-svg";

const PdBell: FC<{ style?: StyleProp<ViewStyle>; color?: Color }> = ({ style = { height: 18, width: 18 }, color }) => {
  return (
    <Svg style={style} viewBox="0 0 21 21" fill="none">
      <G clipPath="url(#pdbell)" fill={color || "#000"}>
        <Path d="M18.983 9.643a.637.637 0 0 1-.637-.637 9.066 9.066 0 0 0-2.672-6.452.637.637 0 1 1 .901-.9 10.333 10.333 0 0 1 3.044 7.352.637.637 0 0 1-.636.637ZM1.583 9.643a.637.637 0 0 1-.636-.637c0-2.777 1.08-5.389 3.045-7.352a.637.637 0 0 1 .9.9A9.06 9.06 0 0 0 2.22 9.007a.637.637 0 0 1-.637.637ZM10.283 20.889A3.186 3.186 0 0 1 7.1 17.706a.637.637 0 0 1 1.273 0c0 1.053.857 1.91 1.91 1.91s1.91-.857 1.91-1.91a.637.637 0 0 1 1.273 0 3.186 3.186 0 0 1-3.183 3.183Z" />
        <Path d="M17.285 18.343H3.281a1.487 1.487 0 0 1-.966-2.615 5.688 5.688 0 0 0 2.027-4.355V9.006a5.948 5.948 0 0 1 5.941-5.941 5.948 5.948 0 0 1 5.941 5.941v2.367c0 1.68.736 3.265 2.019 4.35a1.485 1.485 0 0 1-.958 2.62ZM10.283 4.338a4.673 4.673 0 0 0-4.668 4.668v2.367c0 2.054-.9 3.995-2.47 5.321a.212.212 0 0 0 .136.375h14.004a.215.215 0 0 0 .212-.212.209.209 0 0 0-.074-.161 6.959 6.959 0 0 1-2.472-5.323V9.006a4.673 4.673 0 0 0-4.668-4.668Z" />
        <Path d="M10.283 4.338a.637.637 0 0 1-.637-.637V1.155a.637.637 0 0 1 1.274 0v2.546a.637.637 0 0 1-.637.637Z" />
      </G>
      <Defs>
        <ClipPath id="pdbell">
          <Path fill={color || "#000"} transform="translate(.111 .519)" d="M0 0h20.37v20.37H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default PdBell;
